import WAboutCompareDetails from './WAboutCompareDetails'

export default WAboutCompareDetails
